import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ArrowIcon = ({ className }) => (
  <svg className={ className ? className + ' bb-arrow-icon' : 'bb-arrow-icon' }
    viewBox="0 0 98.06 66.49">
    <path d="M95.52,30.49H13.89L41.18,6.91a3.5,3.5,0,1,0-4.58-5.3L2.18,31.35a.27.27,0,0,0-.07.08c-.11.1-.21.21-.31.32s-.12.14-.17.22a2.65,2.65,0,0,0-.24.4l-.12.21a5.08,5.08,0,0,0-.17.51c0,.06,0,.12-.05.18a3.37,3.37,0,0,0,0,1.46c0,.06,0,.11.05.17a4.51,4.51,0,0,0,.17.52l.12.21a3.26,3.26,0,0,0,.24.4,1.73,1.73,0,0,0,.17.21,3.26,3.26,0,0,0,.31.33.5.5,0,0,0,.07.08L36.6,66.39a3.5,3.5,0,0,0,4.58-5.3L13.89,37.5H95.52a3.51,3.51,0,1,0,0-7Z" transform="translate(-0.97 -0.76)"/>
  </svg>
);

ArrowIcon.propTypes = {
  className: PropTypes.string
};

export default ArrowIcon;
